import React from 'react';
import ArrowRightIcon from 'assets/ic_arrow_right.svg';
import { LivenLogoHeader } from 'onboarding/components/livenlogoheader/LivenLogoHeader';
import { Genders, useLivenWelcomeLogic } from './LivenWelcome.hook';
import styles from './styles.module.scss';

export const LivenWelcome = () => {
  const { handleTakeTest } = useLivenWelcomeLogic();

  return (
    <div className={styles.wrapper}>
      <LivenLogoHeader className={styles.header} />
      <div className={styles.contentWrapper}>
        <h5>TAKE ADHD TEST</h5>
        <h3>FIND YOUR TRIGGERS TO START YOUR WELLBEING JOURNEY</h3>
        <p>3-MINUTE QUIZ</p>
        <div className={styles.genderButtons}>
          <div
            className={styles.appButtonImage}
            onClick={(e) => handleTakeTest(e, Genders.Male)}
          >
            <div className={styles.buttonContent}>
              <img
                className="image"
                src="https://imagedelivery.net/yV7GQhi_zl7Pdn3EJrn61Q/7fd2c6d3-3fdc-400a-b56a-522b49025f00/public"
                alt="A person aged Male"
              />
            </div>
            <button className={styles.footerButton}>
              <p className="app-text p2">Male</p>
              <img src={ArrowRightIcon} alt="" />
            </button>
          </div>
          <div
            className={styles.appButtonImage}
            onClick={(e) => handleTakeTest(e, Genders.Female)}
          >
            <div className={styles.buttonContent}>
              <img
                data-v-2b3efdb9=""
                className="image"
                src="https://imagedelivery.net/yV7GQhi_zl7Pdn3EJrn61Q/aed5a4d6-7acc-4a0a-7c72-56acc36e6900/public"
                alt="A person aged Female"
              />
            </div>
            <button className={styles.footerButton}>
              <p className="app-text p2">Female</p>
              <img src={ArrowRightIcon} alt="" />
            </button>
          </div>
        </div>
        <div className={styles.disclaimer}>
          By clicking “Male” or “Female” you agree with the <br />{' '}
          <a href="https://loona.app/terms.html">Terms of Use</a> and{' '}
          <a href="https://loona.app/privacy.html">Privacy Policy</a>
        </div>
      </div>
    </div>
  );
};
